export default "__VITE_ASSET__d22e61cc__"